import React from 'react'
import { Row, Col, Card, CardBody, CardText } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCastEducation } from '@mdi/js';

import './CourseListItem.css';

const CourseListItem = ({ course, hideDay, actions, className, condensed }) => {
    if (!course)
        return null;

    if (condensed)
        className = (className || '') + ' condensed';

    const { classroom }  = course;

    return (
        <Card className={ `CourseListItem ${className}` }>
            <CardBody>
                <Row className="mb-0">
                    <Col className="col-auto bg-primary">
                        <CardText>
                            <Icon path={ mdiCastEducation } size={1} color="white" />&nbsp;
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            <strong>{ classroom.subject?.name }</strong>
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            { classroom.teacher?.firstname }
                        </CardText>
                    </Col>
                    {!hideDay && (
                    <Col>
                        <CardText className="scheduling">
                            { course.getDateText() }
                        </CardText>
                    </Col>
                    )}
                    <Col>
                        <CardText className="scheduling">
                            { course.getTimeText() }
                        </CardText>
                    </Col>
                    { actions && (
                    <Col className="col-auto">
                        <div className="actions">
                            { actions }
                        </div>
                    </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    )
}

export default CourseListItem;
